import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=70352134"
import script from "./refund.vue?vue&type=script&lang=js"
export * from "./refund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports